import { AxiosResponse } from "axios";

import RequestsService from "./requests.service";
import { APIRoutes } from "../http";
import { IResultResponse } from "../models/response/result.model";

export default class SubscribesService {
  static async subscribe(
    email: string
  ): Promise<AxiosResponse<IResultResponse<any>>> {
    return RequestsService.postMethod<IResultResponse<any>>(
      APIRoutes.SUNSCRIBERS,
      {
        email,
        isSubscribe: true,
      }
    );
  }

  static async delete(
    id: number
  ): Promise<AxiosResponse<IResultResponse<any>>> {
    return RequestsService.deleteMethod<IResultResponse<any>>(
      `${APIRoutes.SUNSCRIBERS}`,
      {
        params: {
          id,
        },
      }
    );
  }
}
